// @ts-nocheck
import { createContext } from 'react'

export const SmartBannerContext = createContext<{ isShown: boolean }>()
